export class InitApp {
  static readonly type = '[App] Init App';
  constructor(public agentOtp: string | null, public useRecoveryToken: boolean = false) {}
}

export class SetDisabledCaptcha {
  static readonly type = '[App] Update Disable Captcha';
  constructor(public disableCaptcha: boolean = false) {}
}

export class SetMaintenanceStatus {
  static readonly type = '[App] Update Site Maintenance Status';
  constructor(public isInMaintenance: boolean) {}
}

export class SetRefreshRequiredStatus {
  static readonly type = '[App] Update Refresh Required Status';
  constructor(public isRefreshByModalRequired: boolean) {}
}
